function observeShadowRoot(hostElement, callback, noRoot) {
    const observerTarget = noRoot ? hostElement : hostElement.shadowRoot;
    if (!observerTarget) return;

    let mutationTimeout;
    const runOnce = () => {
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(() => {
            callback();
        }, 1000);
    };

    const shadowObserver = new MutationObserver(() => {
        runOnce();
    });

    shadowObserver.observe(observerTarget, {
        childList: true,
        subtree: true,
        characterData: true,
    });
}

function setupPagerObservers(target, executableFunction, noRoot = false) {
    let elements = [];

    if (typeof target === "string") {
        elements = document.querySelectorAll(target);
    } else if (target instanceof Element) {
        elements = [target];
    } else if (
        NodeList.prototype.isPrototypeOf(target) ||
        Array.isArray(target)
    ) {
        elements = target;
    } else {
        console.warn("setupPagerObservers: Invalid target:", target);
        return;
    }

    // This debouncer ensures the callback runs once per mutation batch
    elements.forEach((pager) => {
        observeShadowRoot(pager, executableFunction, noRoot);
    });

    // Initial run
    executableFunction();
}

function patchPagerButtons() {
    const pagers = document.querySelectorAll("atomic-pager");

    pagers.forEach((pager) => {
        if (!pager.shadowRoot) return;

        const buttons = pager.shadowRoot.querySelectorAll(".btn-radio");
        buttons.forEach((btn, index) => {
            if (!btn.hasAttribute("role")) {
                btn.setAttribute("role", "button");
                btn.setAttribute("name", "pager" + index);
                btn.setAttribute("tabindex", "0");
                $(btn).keydown(function(e){
                    if (e.key === "Enter" || e.keyCode === 13) {
                        console.log(e.target);
                        e.preventDefault();
                        e.stopPropagation();
                        e.target.click();
                    }
                });
            }
        });

        const pageWrapperButton = pager.shadowRoot.querySelector(
            '[part="page-buttons"]'
        );
        pageWrapperButton?.removeAttribute("role");
        pageWrapperButton?.removeAttribute("aria-label");
        const wrapperButton = pager.shadowRoot.querySelector(
            '[part="buttons"]'
        );
        wrapperButton?.removeAttribute("role", "navigation");
    });
}

document.addEventListener("DOMContentLoaded", () => {
    console.log('a11y');
    setupPagerObservers("atomic-pager", patchPagerButtons, false);
});

function handleEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
        console.log(e.target);
        if (e.target.classList?.contains("keyboard-support")) {
            console.log(e.target);
            e.preventDefault();
            e.stopPropagation();
            e.target.click();
        }
    }
}

var $ = jQuery;

$(document).ready(function() {
    document.body.addEventListener("keydown", handleEnterKey, true);
    const isDesktop = window.innerWidth > 765;
    if(isDesktop){
        $('.custom-products.child-nav nav-menu details').attr('role', 'none');
        $('.custom-products.child-nav nav-menu summary').attr('role', 'none');
    }
});
